module.exports = "/_next/static/images/4b3a3ebfb19776111f7bac74fcc2da5b-cajitas-right-desktop.jpg.webp";